import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UtilitatsService } from '../services/utilitats.service';
import { RumiService } from '../services/rumi.service';

/*
Proveidor de dades mestres
*/
@Injectable({
	providedIn: 'root'
})
export class DataProvider {

	private readonly POS_RESULTAT_AMBITS = 0;
	private readonly POS_RESULTAT_EDAT_ESTIMADA = 1;
	private readonly POS_RESULTAT_GRAVETAT = 2;
	private readonly POS_RESULTAT_VALORACIONS = 3;
	private readonly POS_RESULTAT_ACCIONS = 4;

	constructor(
		private rumiService: RumiService,
		private utilService: UtilitatsService
	) { }

	// Muntar array d'operacions a executar
	getArrayOperacions() {
		// Array amb els observables de les crides a mestres a executar en paral·lel
		const arrayOperacions = [];

		// Afegim els observables de les crides a taules mestres
		arrayOperacions.push(this.rumiService.getValorsTaulaMestraByNom('AMBIT'));
		arrayOperacions.push(this.rumiService.getValorsTaulaMestraByNom('EDAT_ESTIMADA'));
		arrayOperacions.push(this.rumiService.getValorsTaulaMestraByNom('GRAVETAT'));
		arrayOperacions.push(this.rumiService.getValoracionsFinals());
		arrayOperacions.push(this.rumiService.getAccions());

		return arrayOperacions;
	}

	// Càrrega inicial de dades
	public load() {

		// Array amb els observables de les operacions a executar en paral·lel
		const arrayOperacions = this.getArrayOperacions();

		this.utilService.showSpinner('Carregant dades...');

		// Amb el forkJoin es llançaran les crides en paral·lel, retornant el resultat quan totes les operacions hagin acabat
		forkJoin(arrayOperacions)
			.subscribe(
				(results) => {
					// Es gestionen els resultats de les operacions
					this.gestionarResultats(results);

					// Executa les tasques rere l'execució de les operacions
					this.execFinishedLoadTasks();
				},
				(error) => {
					//TODO: Gestionar error
					console.log(error);
				}
			);
	}

	// Recollir els resultats i desar-los al servei
	gestionarResultats(results) {
		this.rumiService.ambits = results[this.POS_RESULTAT_AMBITS];
		this.rumiService.unitats_edat_estimada = results[this.POS_RESULTAT_EDAT_ESTIMADA];
		this.rumiService.gravetats = results[this.POS_RESULTAT_GRAVETAT];
		this.rumiService.valoracions = results[this.POS_RESULTAT_VALORACIONS];
		this.rumiService.accions = results[this.POS_RESULTAT_ACCIONS];
	}

	// Executa les tasques rere la càrrega inicial de dades
	public execFinishedLoadTasks() {
		// Ocultar el spinner d'espera
		this.utilService.hideSpinner();
	}

}
